export default {
  order_amount: 'Monto de la orden',
  transaction_fee_charge_mode: 'Modo de asignación de comisión',
  transaction_fee_charge_mode1: 'Asumido por el comercio',
  transaction_fee_charge_mode2: 'Asumido por el usuario / cliente',
  merchant_main_name: 'Nombre de la cuenta',
  merchant_no: 'Número de comercio',
  merchant_name: 'Nombre del comercio',
  merchant_type: 'Tipo de comercio',
  merchant_origin: 'Canal de registro',
  industry_category: 'Naturaleza de la empresa',
  add_merchant: 'Agregar comercio',
  service_fee: 'Tarifa de servicio',
  settlement_bank: 'Nombre del banco de liquidación',
  settlement_bank_account: 'Titular de la cuenta de liquidación',
  settlement_bank_num: 'Número de cuenta de liquidación',
  contract_effect_time: 'Fecha de entrada en vigor del contrato',
  contract_validity_start: 'Inicio de vigencia del contrato',
  contract_validity_end: 'Fin de vigencia del contrato',
  merchant_status: 'Estado de vigencia del contrato',
  merchant_payment_type: 'Servicios habilitados para el comercio',
  payment_combination: 'Esquema de tarifas combinadas (Cobro)',
  payout_combination: 'Esquema de tarifas combinadas (Desembolso)',
  channel_fee_id: 'ID de tarifa del canal',
  payment_institution_name: 'Institución de pago / Adquirente',
  fee_type: 'Tipo de tarifa',
  payment_institution_contract_costs: 'Costo contractual de la institución',
  external_quotation: 'Cotización externa de Unlock',
  unlock_quotation: 'Cotización de Unlock',
  fee_structure: 'Modelo de cobro',
  combination_name: 'Nombre del esquema tarifario combinado',
  available_channels: 'Canales disponibles',
  legal_person_name: 'Nombre del representante legal',
  legal_person_mobile: 'Teléfono del representante legal',
  legal_person_id_num_type: 'Tipo de documento del representante legal',
  legal_person_id_num: 'Número de documento del representante legal',
  legal_person_email: 'Correo electrónico del representante legal',
  contract_name: 'Nombre de la persona de contacto',
  contract_mobile: 'Teléfono celular del contacto',
  contract_id_num_type: 'Tipo de documento de identidad del contacto',
  contract_id_num: 'Número de documento de identidad del contacto',
  contract_email: 'Correo electrónico del contacto',
  legal_person_id_num_upload: 'Subir foto del documento de identidad',
  upload_id_face_card: 'Subir la foto del anverso del documento de identidad',
  upload_id_back_card: 'Subir la foto del reverso del documento de identidad',
  contract_validity_period: 'Período de validez del contrato',
  legal_person_id_num_info: 'Información de identidad del representante legal',
  add_merchant_app: 'Añadir aplicación de comercio',
  update_merchant_app: 'Actualizar aplicación de comercio',
  merchant_app_detail: 'Detalles de la aplicación de comercio',
  callback_event_list: 'Lista de eventos de callback',
  app_name: 'Nombre de la aplicación',
  appkey: 'AppId',
  app_secret: 'Clave secreta',
  notice_webhook: 'Webhook de notificaciones para el comercio',
  qrcode_webhook: 'Webhook para QR',
  transfer_webhook: 'Webhook para transferencias bancarias',
  collect_url: 'URL de confirmación del comercio (API)',
  validate_url: 'URL de consulta del comercio (API)',
  public_key: 'Clave pública',
  shared_application_setting: 'Configuración de aplicación compartida',
  secret_key: 'Clave secreta',
  white_ips: 'Lista blanca de direcciones IP',
  ips_tips: '(Las IPs se separan por comas sin espacios)',
  account_open_time: 'Fecha y hora de apertura de cuenta',
  to: 'a',
  merchant_basic_info: 'Información básica del comercio',
  account_name: 'Titular de la cuenta bancaria',
  account_num: 'Número de cuenta bancaria',
  withdrawal_account: 'Cuenta de retiros',
  account_bank: 'Nombre del banco',
  account_address: 'Dirección del banco',
  company_address: 'Dirección de la empresa',
  bank_list: 'Lista de bancos',
  recharge: 'Recargar',
  withdraw: 'Retirar fondos',
  account_balance: 'Saldo de la cuenta',
  bank_payee: 'Banco del beneficiario',
  payment_institution: 'Canal de cobro (Pay-in)',
  payout_institution: 'Canal de pago (Payout)',
  choose_bank_payee: 'Seleccionar banco del beneficiario',
  payment_channel: 'Canal de pago',
  receiving_channel: 'Canal de recepción',
  institute_name: 'Nombre de la institución',
  level_id: 'Nivel de riesgo',
  institute_rate_type: 'Tipo de tasa',
  institute_cost: 'Costo de la institución',
  institute_cost_step_begin: 'Inicio de rango escalonado',
  institute_cost_step_end: 'Fin de rango escalonado',
  profile_pic: 'Foto de perfil',
  merchant_logo: 'Logo del comercio',
  settlement_method: 'Método de liquidación',
  notification_email: 'Correo de notificaciones',
  notification_phone: 'Teléfono de notificaciones',
  jt_institute_way_code: 'Canal de procesamiento de pagos'
}
